import { useNotifications } from '@/stores/notifications';

import { Notification } from './notification';

export function Notifications() {
  const { notifications, dismissNotification } = useNotifications();

  return (
    <div className="fixed w-sm z-(--z-notification) right-0 max-h-40">
      {notifications.map(notification => (
        <Notification
          key={notification.id}
          notification={notification}
          onDismiss={dismissNotification}
        />
      ))}
    </div>
  );
}
